import React from 'react'
import { useAuth } from '../../contexts/AuthContext'

export default function CurrencyDisplay({ amount }) {
  const { currentUser } = useAuth()
  const formatPrice = () => {
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })

    const currency = currentUser?.currencyCode || 'KES'
    return `${currency} ${formatter.format(amount)}`
  }

  return formatPrice()
}
